var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.0277 22L18.747 0H13.4387L0 22H12.0277ZM27.2806 22L34 0H28.6917L15.2529 22H27.2806Z","fill":"#303030","fillOpacity":"0.3"}));
}

Quote.defaultProps = {"width":"34","height":"22","viewBox":"0 0 34 22","fill":"none"};

module.exports = Quote;

Quote.default = Quote;
